// extracted by mini-css-extract-plugin
export default {"clients":"clients_clients__Ah80G","client_slide":"clients_client_slide__MB3TR","client_logo":"clients_client_logo__PMkUL"};